import { Container, Col, Row, Card } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import { FaArrowRight } from "react-icons/fa6";
import Arrow from "/public/site-assets/svg/black-arrow.svg";

import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const MultiColumnCTABox = ({
  className,
  title,
  content,
  textAlign,
  items,
  swiperID = "multiColumnSwiper",
}) => {
  if (!items || !items.length > 0) {
    return null;
  }

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .${swiperID}`,
    },
    navigation: {
      nextEl: `.${swiperID}.swiper-next`,
      prevEl: `.${swiperID}.swiper-prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="position-relative">
        <div className={`${textAlign} mb-5`}>
          {title && <h2>{title}</h2>}
          {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
        </div>

        {items.length > 4 ? (
          <>
            <div className="d-flex swiperArrowWrapper justify-content-end mb-4">
              <button
                className={`${swiperID} arrow swiper-prev border-0 p-0`}
                aria-label="Prev"
              >
                <Arrow />
              </button>
              <button
                className={`${swiperID} arrow swiper-next border-0 ms-2 p-0`}
                aria-label="Next"
              >
                <Arrow />
              </button>
            </div>
            <Swiper {...settings}>
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  <Link href={item.url_slug}>
                    <a
                      className="text-decoration-none h-100 d-block"
                      target={item.newTab ? "_blank" : "_self"}
                    >
                      <Card
                        className={`p-4 pb-5 h-100 overflow-hidden ${item.bgColor}`}
                      >
                        <h5>{item?.title}</h5>
                        {item?.description && (
                          <div
                            className="mt-2"
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          />
                        )}
                        <div className="position-absolute cta py-2 ps-2 d-inline-flex align-items-center position-relative">
                          <span className="arrow">
                            <FaArrowRight />
                          </span>
                          <span className="read-more">
                            <strong>Read More</strong>
                          </span>
                        </div>
                      </Card>
                    </a>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </>
        ) : (
          <Row>
            {items.map((item, index) => (
              <Col key={index} md={6} lg={4} xl={3} className="item mb-4">
                <Link href={item.url_slug}>
                  <a
                    className="text-decoration-none h-100 d-block"
                    target={item.newTab ? "_blank" : "_self"}
                  >
                    <Card
                      className={`border-4 border-white p-4 pb-5 h-100 overflow-hidden ${item.bgColor}`}
                    >
                      <h5>{item?.title}</h5>
                      {item?.description && (
                        <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      )}
                      <div className="position-absolute cta py-2 ps-2 d-inline-flex align-items-center position-relative">
                        <span className="arrow">
                          <FaArrowRight />
                        </span>
                        <span className="read-more">
                          <strong>Read More</strong>
                        </span>
                      </div>
                    </Card>
                  </a>
                </Link>
              </Col>
            ))}
          </Row>
        )}
        {/* <span className="position-absolute overlayBg">
          <img
            src={"/site-assets/svg/rounded-corner.svg"}
            alt="Rounded Corner"
          />
        </span> */}
      </Container>
    </section>
  );
};

export default MultiColumnCTABox;
